export enum availableLocalesEnum {
  ru = "ru",
  en = "en"
}

export const roles = {
  carrier: 0, // Перевозчика
  shipper: 1, // Экспедитора
  topShipper: 2, // ТОП экспедитора
  fuel: 3, // Займ топлива
};

export const availableLocales = Object.values(availableLocalesEnum);
